/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MineInputs */

const cs_enum_mine = /** @type {(inputs: Enum_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen já`)
};

const en_enum_mine = /** @type {(inputs: Enum_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine`)
};

/**
* | output |
* | --- |
* | "Mine" |
*
* @param {Enum_MineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_mine = /** @type {((inputs?: Enum_MineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_mine(inputs)
	return cs_enum_mine(inputs)
});